import React, { useEffect } from 'react'
import { Carousel } from 'antd';
import img1 from '../../images/carousel1.jpg'
import img2 from '../../images/carousel2.jpg'

function HomeCarousel() {
  return (
      <div className="">
        <Carousel autoplay effect="scrollx" dotPosition="bottom">
            <div>
                <div className="" style={{height: "83vh"}}>
                    <img className="h-full w-full object-cover" src={img1} alt=""/>
                </div>
            </div>
            <div>
                <div className="" style={{height: "83vh"}}>
                    <img className="h-full w-full object-cover" src={img2} alt=""/>
                </div>
            </div>
            <div>
                <div className="" style={{height: "83vh"}}>
                    <img className="h-full w-full object-cover" src={img1} alt=""/>
                </div>
            </div>
            <div>
                <div className="" style={{height: "83vh"}}>
                    <img className="h-full w-full object-cover" src={img2} alt=""/>
                </div>
            </div>
        </Carousel>
    </div>
  );
}

export default HomeCarousel;
